module.exports={
    "over_size_message":"Przesłany obraz ma ponad 10MB. Skompresujemy Twój plik do przesłania. Kliknij „Potwierdź”, aby kontynuować przesyłanie.",
    "file_type_error":"Przesłany plik nie jest obrazem! Spróbuj przesłać ponownie.",
    "upload_error":"Błąd przesyłania! (Kod błędu: 2000) Spróbuj ponownie.",
    "watermark_remove_over_size":"Przesłany obraz ma ponad 5MB. Zaleca się korzystanie z naszego bezpłatnego internetowego kompresora obrazów. Kliknij, aby <a class=\"jump-link\" href=\"https://www.anymp4.com/pl/image-compressor-online/\">dowiedzieć się więcej</a>",
    "watermark_remove_file_type_error":"Przesłany plik nie jest obrazem, prześlij ponownie.",
    "watermark_remove_image_type_error":"Format obrazu nie jest obsługiwany. Obsługujemy tylko JPG, JPEG, PNG i BMP.",
    "watermark_remove_upload_error":"Błąd rozpoznawania (kod błędu: 2001), spróbuj ponownie...",
    "watermark_remove_processing":"Przetwarzam obraz...",
    "watermark_remove_not_save":"Wybrany obszar nie zostanie zachowany. Czy na pewno chcesz go przyciąć?",
    "watermark_remove_back_home":"Aktualny stan nie zostanie zapisany. Czy na pewno chcesz wrócić do domu?",
    "watermark_remove_new_image":"Aktualny stan nie zostanie zapisany. Czy na pewno chcesz wybrać nowy obraz?",
    "watermark_select":"Wybierz",
    "watermark_select_area":"Wybierz obszar znaku wodnego, który chcesz usunąć, zanim klikniesz Usuń.",
    "watermark_beyond_12k":"Wybrany obraz przekracza rozdzielczość 12K. Przepraszamy, nie możemy go obecnie przetworzyć",
    "watermark_beyond_pixel_1":"Wybrana rozdzielczość obrazu przekracza <span>%spx</span><span>&times;%spx</span>. Nie można go przetworzyć, proszę wybrać ponownie.",
    "watermark_beyond_pixel_2":"Odwiedzający mogą przetwarzać tylko <span>%s</span> obrazy o rozdzielczości powyżej <span>%spx</span>x<span>%spx</span>, zaloguj się i kontynuuj korzystanie.",
    "watermark_beyond_size_1":"Wybrany rozmiar obrazu przekracza <span>%sMB</span>. Nie można go przetworzyć, proszę wybrać ponownie.",
    "watermark_beyond_size_2":"Wybrany rozmiar obrazu przekracza <span>%sMB</span>, ale użytkownicy mogą przetwarzać tylko obrazy mniejsze niż <span>%sMB</span>. Zaloguj się i kontynuuj korzystanie.",
    "no_user_down":"Odwiedzający mogą pobierać tylko obrazy <span>%s</span> w oryginalnej jakości. Zaloguj się i kontynuuj pobieranie. Możesz również zachować 7-dniową historię po zalogowaniu. Kontynuuj pobieranie obrazów o szerokości lub wysokości <span>%spx</span>.",
    "no_down_rights":"Nie można pobrać obrazów HD w oryginalnej jakości, uaktualnij swój plan! Możesz także nadal pobierać obrazy niskiej jakości za pomocą <span>%spx</span>.",
    "error_40001":"Błąd: 40001. Skontaktuj się z nami",
    "error_40099":"Błąd: 40099. Skontaktuj się z nami",
    "down_btn":"Pobieranie jest w przygotowaniu, proszę poczekać chwilę...",
    "noRemove_down_btn":"Nie zrobiłeś nic dla usunięcia znaków wodnych. Wybierz znak wodny, który chcesz usunąć, i kliknij przycisk Usuń. Następnie możesz pobrać swój obraz.",
    "history_open":"Otwarcie zmodyfikowanego obrazu, proszę chwilę poczekać...",
    "maskRightsMonitor_info":"Strona aktualizacji korzyści została otwarta w nowej karcie, a Twój plan zostanie automatycznie zsynchronizowany po aktualizacji.",
    "maskLoginMonitor_info":"Strona docelowa została otwarta, wypełnij na niej login. Po pomyślnym zalogowaniu lub rejestracji ta strona zostanie zsynchronizowana automatycznie, nie zamykaj jej.",
    "photo_rights_info":"Obecnie można pobrać <span><i class=\"num\">2</i> obrazy HD</span> w oryginalnej jakości. <a href=\"https://account.anymp4.com\" target=\"_blank\">Wyświetl szczegóły>></a>",
    "rights_original":"Aby włączyć ustawienie „Użyj funkcji Image Enhancer, aby zmniejszyć utratę jakości”, musisz uaktualnić swoje konto!",
    "Brush":"Szczotka",
    "Lasso":"Lasso",
    "Polygonal":"Wielokątny",
    "Eraser":"gumka do mazania",
    "Free":"Wolny",
    "More":"Więcej:",
    "Select":"Wybierz",
    "Remove":"Usunąć",
    "BrushSize":"Rozmiar pędzla:",
    "AspectRatio":"Współczynnik proporcji:",
    "Upload":"Nowe zdjęcie",
    "History":"Historia",
    "Login":"Zaloguj sie",
    "MyAccount":"Moje konto",
    "Logout":"Wyloguj",
    "Usinghelp":"Korzystanie z pomocy>>",
    "Enhancer":"Użyj funkcji Image Enhancer, aby zmniejszyć utratę jakości",
    "Download":"Pobierać",
    "Guide":"Przewodnik",
    "Polygonal1":"Wielokątny",
    "Polygonal_info":"Kliknij lewym przyciskiem myszy, aby zidentyfikować punkt na raz.",
    "Lasso1":"Lasso:",
    "Lasso_info":"Naciśnij i przytrzymaj lewy przycisk myszy, aby lassować obszar znaku wodnego.",
    "Brush1":"Szczotka:",
    "Brush_info":"Naciśnij i przytrzymaj lewy przycisk myszy, aby wybrać precyzyjnie.",
    "Eraser1":"Gumka do mazania:",
    "Eraser_info":"Usuń niepotrzebne części z wybranego obszaru.",
    "Click":"Kliknij",
    "the":"ten",
    "click_info":"przycisk, aby rozpocząć usuwanie niechcianego znaku wodnego.",
    "PleaseUploadImages":"Prześlij obrazy.",
    "CropInfo":"Po zakończeniu usuwania znaku wodnego możesz kliknąć przycisk Przytnij, aby przyciąć zdjęcie przed zapisaniem, lub kliknij przycisk Pobierz, aby bezpośrednio zapisać bieżący obraz.",
    "Crop":"Przyciąć",
    "Back":"Z powrotem",
    "DownloadCropped":"Pobierz przycięte",
    "Cancel":"Anulować",
    "FreeWatermarkRemover":"Bezpłatne usuwanie znaków wodnych",
    "Processing":"Przetwarzanie...",
    "NewImage":"Nowy wygląd",
    "Retry":"Spróbować ponownie",
    "Yes":"Tak",
    "No":"Nie",
    "FailureFeedback":"Informacje zwrotne o awarii",
    "removeTip":"Po wybraniu obszaru znaku wodnego kliknij Usuń, aby usunąć znak wodny.",
    "rightDown":"Pobierz obrazy o niskiej jakości",
    "history_will":"Wygaśnie po",
    "Expired":"(Wygasły)",
	"uploadImage":"Załaduj obrazek",
    "uploadImageInfo":"Lub upuść tutaj plik obrazu, aby usunąć znak wodny!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain TWO HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"bez limitu",
    "watermark_beyond_pixel_3":"Wybrany obraz przekracza <span>%s&times;%s rozdzielczość</span>, najpierw uaktualnij swój plan.",
    "watermark_beyond_size_3":"Wybrany obraz przekracza <span>%sMB</span>, najpierw zaktualizuj swój plan.",
    "no_user_login":"Nowi użytkownicy, którzy się zalogują, mogą uzyskać DWA korzyści z pobierania oryginalnych obrazów HD.<span class=\"loginMaskbtn\">Zaloguj się natychmiast>></span>",
    "Upgrade":"Aktualizacja",
    "Loading":"Ładowanie…",
    "SelectAll":"Zaznacz wszystko",
    "Open":"otwarty",
    "Delete":"Usunąć",
    "Clear":"Wyczyść niepoprawny",
    "noHistory":"Brak historii",
    "Close":"Blisko",
    "buyUserInfo":"gratulacje! Uaktualniłeś pomyślnie. Wróć do strony głównej i skorzystaj z tego produktu.",
    "buyNoUserInfo":"Gratulacje! Uaktualniłeś pomyślnie. Korzyści zostały przypisane do adresu e-mail, który zostawiłeś podczas aktualizacji. Użyj konta zarejestrowanego lub połączonego z adresem e-mail, aby <span class=\"loginMaskbtn\">zalogować się w celu korzystania z korzyści</span>. Jeśli nie zarejestrowałeś lub nie połączyłeś konta z adresem e-mail, <span class=\"registerMaskbtn\">użyj adresu e-mail, aby zarejestrować konto</span> lub połącz inne konta z tym adresem e- adres pocztowy do korzystania z korzyści.",
    "GetStarted":"Zaczynaj",
    "AccessTo":"Dostęp do:",
    "imagesOfwatermarkremoval":"zdjęcia usuwania znaku wodnego",
    "upTo":"Aż do",
    "perImage":"na obraz",
    "Support":"Wsparcie",
    "resolution":"rezolucja",
    "PrepaidPackage":"Pakiet przedpłacony",
    "PayasYouGo":"Płać na bieżąco",
    "TaxIncl":"z podatkiem",
    "Checkout":"Sprawdzić",
    "imagesDay":"obrazów/dzień",
    "imagesMonthly":"obrazów/miesięcznie",
    "image":"obraz",
    "images":"zdjęcia",
    "imageSize":"rozmiar obrazu",
    "buyInfo1":"Integracje <span>ulepszaczy</span> innych firm",
    "buyInfo2":"Historia edycji jest ważna przez 7 dni",
    "buyInfo3":"Przetwarzanie priorytetowe",
    "buyInfo4":"Obsługa klienta 7x24",
    "buyInfo5":"Wygasł po 24 godzinach",
    "buyInfo6":"Brak subskrypcji. Bez automatycznego odnawiania!",
    "buyInfo7":"Dostępne do użytku w każdej chwili na zawsze",
    "dayPlan":"Plan 1-dniowy",
    "Lifetime":"Dożywotni",
}